import {getToken, onMessage} from 'firebase/messaging'
import {getFirebaseMessaging} from '@/firebase'
import {client} from '@/stores/client.js'

export async function getFCMToken(automatic = false) {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return null
  }

  let permission

  try {
    if (automatic) {
      permission = Notification.permission
    } else {
      // Keep this call directly inside the user's click flow for iOS/Safari.
      permission = await Notification.requestPermission()
    }

    if (permission !== 'granted') {
      return null
    }

    const messaging = await getFirebaseMessaging()
    if (!messaging) {
      return null
    }

  const token = await getToken(messaging, {
    vapidKey: 'BEq-R1EgZ1ffkiGrLV2WfluoLxv2aoHOHy_H2U9-9248ezdaHhMCBIuog6rVlMzcnwJIuPklX_707XBkbNr9b7A'
  })

    client.firebaseID = token
    localStorage.setItem('firebaseID', token)

    return {
      permission,
      token,
    }
  } catch (error) {
    console.warn('Unable to enable Firebase notifications.', error)
    return null
  }
}

export async function listenNotifications(callback) {
  try {
    const messaging = await getFirebaseMessaging()
    if (!messaging) {
      return null
    }

    return onMessage(messaging, (payload) => {
      if (callback) {
        callback(payload)
      }
    })
  } catch (error) {
    console.warn('Unable to listen for Firebase notifications.', error)
    return null
  }
}
